import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "10px",
  },
  paper: {
    display: "flex",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    gap: "10px",
    justifyContent: "space-between",
    boxShadow: "none",
    borderRadius: 15,
    borderBottom: "#e8e9ee 2px solid",
  },
  topSection: {
    display: "flex",
    gap: 16,
    alignItems: "center",
  },
  bigText: {
    fontSize: 20,
    fontWeight: 600,
  },
  roleText: {
    textAlign: "center",
    fontSize: 20,
    fontWeight: 600,
  },
  roleBox: {
    padding: theme.spacing(1, 2),
    borderRadius: 10,
  },
  smallRoleText: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: 600,
  },
  smallRoleBox: {
    padding: theme.spacing(1, 2),
    borderRadius: 10,
  },
  whiteColor: {
    color: "white",
  },
  blackColor: {
    color: "black",
  },
  standardTheme: {
    background: "#3366cc",
  },
  abscentTheme: {
    background: "#7E5987",
  },
  rescueTheme: {
    background: "#06A51D",
  },
  standbyTheme: {
    background: "#6A264B",
  },
  trainingTheme: {
    background: "#FEC104",
  },
  qualityTheme: {
    background: "#FF4741",
  },
  specialTheme: {
    background: "#67D3F3",
  },
  availableTheme: {
    background: "#C6F7D2",
  },
  cancelledTheme: {
    background: "#3b3b3b",
  },
  flexTheme: {
    background: "#ff9cb9",
  },
  dispatcherTheme: {
    background: "#E2C975",
  },
  supervisorTheme: {
    background: "#9345E0",
  },
  fleetCoordinatorTheme: {
    background: "#57E7B0",
  },
  leadDriverTheme: {
    background: "#FFF140",
  },
  helperTheme: {
    background: "#35eb13",
  },
  rejectedTheme: {
    background: "#EB001F",
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: 15,
    border: "none",
    // height: "80vh",
  },
  tableCell: {
    padding: theme.spacing(2),
    cursor: "default",
    textAlign: "center",
    background: "white",
  },
  tableDateCell: {
    height: 80,
  },
  cellHover: {
    transition: "0.3s",
    "&:hover": {
      background: "#f6f6f6",
    },
  },
  cellDisabled: {
    background: "#ececec",
    "&:hover": {
      background: "#e2e2e2",
    },
  },
  tableCellContent: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  rightBorderCell: {
    borderRight: "1px solid lightGrey",
  },
  leftBorderCell: {
    borderLeft: "1px solid lightGrey",
  },
  headText: {
    fontSize: 16,
  },
  headDeskText: {
    display: "block",
  },
  headMobileText: {
    display: "none",
  },
  contentBox: {
    padding: theme.spacing(0, 3, 3),
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  bottomDetails: {
    display: "flex",
    textAlign: "center",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    justifyContent: "space-around",
  },
  detailsBox: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  descBox: {
    display: "flex",
    gap: 12,
  },
  warningColor: {
    width: "100%",
    background: "#f5f7c6",
  },
  daHomePaper: {
    display: "flex",
    gap: 10,
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  "@media (max-width: 820px)": {
    smallRoleBox: {
      padding: theme.spacing(0.5),
      borderRadius: 10,
    },
    smallRoleText: {
      fontSize: 9,
    },
    tableCell: {
      padding: theme.spacing(1),
    },
    headText: {
      fontSize: 12,
      fontWeight: 600,
    },
    headDeskText: {
      display: "none",
    },
    headMobileText: {
      display: "block",
    },
    tableDateCell: {
      height: 55,
    },
    daHomePaper: {
      justifyContent: "center",
    },
  },
}));
